import { createResource } from "~/lib/resourceFactory";
import { getChatSession, listChatSessions } from "./chat.api";

type SessionsList = Awaited<ReturnType<typeof listChatSessions>>;
type SessionDetail = Awaited<ReturnType<typeof getChatSession>>;

export const chatSessionsResource = createResource<SessionsList, undefined>({
  key: (_) => ["chat", "sessions"] as const,
  fetcher: (_) => listChatSessions(),
});

export const chatSessionResource = createResource<SessionDetail, string>({
  key: (sessionId: string) => ["chat", "session", sessionId] as const,
  fetcher: (sessionId: string) => getChatSession({ data: { sessionId } }),
});
